import React from 'react';
import SEO from '../components/SEO';
import './Pricing.css';

function Pricing() {
  const plans = [
    {
      name: 'Базовый',
      price: '500₽',
      level: 1,
      fps: '~+20 FPS',
      features: [
        'Оптимизация I/O операций',
        'Запланированная сборка мусора',
        'Настройка интервала обновления сущностей',
        'Поддержка через email'
      ]
    },
    {
      name: 'Продвинутый',
      price: '1000₽',
      level: 2,
      fps: '~+40 FPS',
      features: [
        'Все возможности базового плана',
        'Агрессивная сборка мусора',
        'Сниженная частота обновления сущностей',
        'Оптимизация сетевых пакетов',
        'Приоритетная поддержка'
      ]
    },
    {
      name: 'Максимальный',
      price: '1500₽',
      level: 3,
      fps: '~+60 FPS',
      features: [
        'Все возможности продвинутого плана',
        'Максимальная сборка мусора',
        'Минимальная частота обновления сущностей',
        'Агрессивная оптимизация сетевых пакетов',
        'Оптимизация конвейера рендеринга',
        'Настройка частоты обновления физики',
        'Персональная поддержка'
      ]
    }
  ];

  return (
    <div className="pricing">
      <SEO 
        title="Тарифные планы OptimizeRust - Цены на плагин оптимизации Rust"
        description="Выберите тарифный план OptimizeRust: Базовый (500₽, ~+20 FPS), Продвинутый (1000₽, ~+40 FPS) или Максимальный (1500₽, ~+60 FPS). Оптимизация сервера Rust."
        keywords="optimizerust цена, rust плагин цена, оптимизация rust цена, тарифы rust плагин"
      />
      <section className="section">
        <div className="container">
          <h1 className="section-title">Тарифные планы</h1>
          <p className="section-subtitle">
            Выберите план, который подходит для вашего сервера
          </p>
          <div className="pricing-grid">
            {plans.map((plan, index) => (
              <div key={index} className="pricing-card">
                <div className="pricing-header">
                  <h3 className="pricing-name">{plan.name}</h3>
                  <div className="pricing-fps">{plan.fps}</div>
                  <div className="pricing-price">{plan.price}</div>
                </div>
                <ul className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="pricing-feature">{feature}</li>
                  ))}
                </ul>
                <button 
                  className="btn btn-primary pricing-btn"
                  onClick={() => alert('Для покупки обратитесь к администратору')}
                >
                  Купить
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;

